module.exports = function(bootstrap) {
	bootstrap.service("UMSParse", ["$cookies", "brand", function($cookies, brand) {

        "use strict";
        /**
        ums parser for mer -
        I tried to incorporate parts of the 'user.js' file from mhs.
        I do need to take soem time to break this file apart to have peices that dont' need to be here
        in the app instead.
        Time does need to be spent adding back in 'ALL' methods that mhs uses. 
        methods exposed (non helper methods)
            please look at the service response to have a better idea of what is being refered too here.
            - baseInformation 
            - clients - list of clients
            - fullGroupList - full list of groups
            - clientGroupList - list of groups per client( zero based int arguement)
            - memberGroupList - not done yet
            - fullProductList - full list of products - no duplicates
            - clientProductList - list of products per client (int for client)
            - groupProductList - list of products per group (int client, int group)
            - memberProductList - not done yet
            - fullMemberList - full list of member no dups
            - clientMemberList - list of members in a client (int)
            - groupMemberList - list of members in a group (int client , int group)
            - memberListOfClients - list of members with clients they are related too in them
            - memberListOfProducts
        */

        /** Constructor function. UMSParse
            This exposes the functions below
            I don't think I have anything not in this return.
        */

        return function UMSParse(data, date) {
            /** declaration of default values*/
            var self = this;
            var umsOriginal = data;
            var umsData = angular.copy(umsOriginal);
            var serverDate = date;
            var filterState = "current";
            //console.log(data);
            /**getServerDate - returns the severdate which is passed in.*/

            var getServerDate = function() {
                return serverDate;
            };

            /**clientGroupList - returns list of groups for a client
            the passed in argument is a zero based int of the clients */
            var clientGroupList = function(clientInt) {
                // returns list of groups for a client - pass in client as a int 
                // if int doesnt' exist - default it to 0
                // eliminates duplicates
                var clientGroupList = [],
                    tempGroupNumberListForComparison = [],
                    clientList = getClients();

                clientList = clientList[clientInt] || clientList[0];

                (clientList.groupList || []).forEach(function(vala, indb) {
                    if (tempGroupNumberListForComparison.indexOf(vala.groupNumber) == -1) {
                        tempGroupNumberListForComparison.push(vala.groupNumber);
                        clientGroupList.push(vala);
                    }
                });

                //console.log("clientGroupList",clientGroupList );
                return clientGroupList;
            };


            /*this is populating but not being used for july - code is staying in for after this.
            THIS IS FOR THE PREEFFECTUATED STUFF ON FUTURE DATES*/
            var paidState = function(effectuatedDate, date) {
                if (effectuatedDate == null || effectuatedDate == "") {
                    return "unknown";
                }
                var state,
                    effDate = new Date(effectuatedDate);

                if (effDate > date) {
                    state = "unpaid";
                } else {
                    state = "paid";
                }
                return state;
            };

            /**getMemberDOBValue - this is used to sort users based on date of birth. subscribers first
            There was once part where the spouse came second - have not included that due to what hte tester
            said they were testing with this.*/
            var getMemberDOBValue = function(list) {
                var placementValue = 2;
                // if subscriber - ignore otherwise
                // placement in order of dob
                // run sort on 
                var newDates = [];
                (list || []).forEach(function(vala, inda) {
                    if (vala.relationship == "Subscriber") {
                        vala.placement = 0;
                    } else if (vala.relationship == "Spouse") {
                        vala.placement = 1;
                    } else {
                        newDates.push({
                            "dob": new Date(vala.dob).getTime(),
                            "val": vala
                        });
                    }
                });
                newDates.sort(function(a, b) {
                    return (a.dob > b.dob ? 1 : -1);
                });
                (newDates || []).forEach(function(valb, indb) {
                    valb.val.placement = placementValue++;
                });
                list.sort(function(a, b) {
                    return (a.placement > b.placement ? 1 : -1);
                });
            };


            /**runSortOn runs a sort on an object in an array - in this case it is always 'placement'*/
            var runSortOn = function(arr, depth) {
                // depth doesnt' do anything... 
                // sort on objects 
                arr.sort(function(a, b) {
                    if (a.placement > b.placement) {
                        return 1;
                    } else if (a.placement === b.placement) {
                        return 0;
                    } else {
                        return -1;
                    }
                });
            };

            /**toCamelCase - from user.js (actually set as a prototype in main) names in the ums are all all captialized. this coverts them to lower case
            and capitalizes the first letter of any 'val' passed in.*/
            var toCamelCase = function(val) {
                if (val) {
                    return val.charAt(0).toUpperCase() + val.substr(1).toLowerCase();
                }
            };

            /** getPlanIcon - helps to be build iconList arrays for products/groups and cards arrays
            The value returned is the css class for each icon type.*/
            var getPlanIcon = function(benefitPlanType) {
                var planIcon = "";
                switch (benefitPlanType) {
                    case "Medical":
                        planIcon = "icon-provider";
                        break;
                    case "Dental":
                        planIcon = "icon-dental";
                        break;
                    case "Prescription Drug":
                    case "Drug":
                        planIcon = "icon-pharmacy";
                        break;
                    case "Vision":
                        planIcon = "icon-vision";
                        break;
                    case "Wellness Programs":
                        planIcon = "icon-nutrition";
                        break;
                    default:
                        planIcon = "";
                        break;
                }
                return planIcon;
            };

            /**getPlanValue - plans are to be ordered 'medical' 'dental' 'drug' 'vision'
            This plan sets a placement value in a product level based on the benefitplantype that can then be sorted.*/
            var getPlanValue = function(benefitPlanType) {
                var planValue = 0;
                switch (benefitPlanType) {
                    case "Medical":
                        planValue = 0;
                        break;
                    case "Dental":
                        planValue = 1;
                        break;
                    case "Vision":
                        planValue = 2;
                        break;
                    case "Drug":
                    case "Prescription Drug":
                        planValue = 3;
                        break;
                    default:
                        planValue = 4;
                        break;
                }
                return planValue;
            };

            /**buildCards-  for the membership information page I need to add in a 'cards' array
            The cards are split apart based on integratedcoverageindicator (at product level)
            then all needed information for a card is passed into the card object 
            the card object then populates the 'cards' array for each member.*/
            var buildCards = function(list) {
                var that = this;
                var firstmember = true;
                var firstMemberReachedFlag = false;
                (list.clientList || []).forEach(function(vala, inda) {

                    (vala.members || []).forEach(function(valb, indb) {
                        // new card array here
                        // build obj to compare here.
                        var memObj1 = {
                            'ecId': valb.ecId,
                            'firstName': valb.firstName,
                            'lastName': valb.lastName,
                            'dob': valb.dob
                        };
                        valb.cards = [];
                        (valb.groups || []).forEach(function(valc, indc) {
                            var wellnessProdArray = [];
                            var intProdArray = [];
                            var nonIntProdArray = [];
                            var nonIntCards = [];
                            (valc.products || []).forEach(function(vald, indd) {
                                (vald.memberList || []).forEach(function(valm, indm) {
                                    var memObj2 = {
                                        'ecId': valm.ecId,
                                        'firstName': toCamelCase(valm.contact.firstName),
                                        'lastName': toCamelCase(valm.contact.lastName),
                                        'dob': valm.contact.birthDate
                                    };
                                    var compare = angular.equals(memObj1, memObj2);
                                    if (compare) {
                                        if (valm.coverageCancellationDate === valm.coverageEffectiveDate) {
                                            vald.can = "NC";
                                        } else {
                                            vald.can = valm.coverageCancellationDate || false;
                                        }
                                    }
                                });
                            });

                            var skippedAgProducts = [];
                            (valc.products || []).forEach(function(vald, indd) {
                                // first find all products int true in a group and 
                                // add them to a obj... 
                                // if (vald.integratedCoverageIndicator === "true") {
                                if (vald.lob && vald.lob.toLowerCase() == "ag") {
                                    if (vald.benefitPlanType && vald.benefitPlanType.toLowerCase() !== "spending accounts") {
                                        skippedAgProducts.push(vald);
                                    }
                                } else if (valc.consolidatedIdCardIndicator === "true" || vald.integratedCoverageIndicator === "true") {
                                    intProdArray.push(vald);
                                } else {
                                    nonIntProdArray.push(vald);
                                }
                            });

                            var extraIntArray = [];

                            if (skippedAgProducts && skippedAgProducts.length > 0) {
                                // We skipped some products from this group.
                                // If this group has medical coverage, then these AG products must roll into that.
                                // First check the intProdArray, if there is a medical plan, then we'll slip these products into that
                                var finished = false;
                                (intProdArray || []).forEach(function(prod) {
                                    var done = false;
                                    if (!done && prod.benefitPlanType && prod.benefitPlanType.toLowerCase() && prod.benefitPlanType.toLowerCase() == "medical") {
                                        // Found an integrated medical plan, push these products there and we're finished
                                        intProdArray = intProdArray.concat(skippedAgProducts);
                                        done = true;
                                        finished = true;
                                    }
                                });
                                if (!finished) {
                                    // There were no medical integrated, so we're gonna look for a standalone medical
                                    for (var zzzz = 0; zzzz < nonIntProdArray.length; zzzz++) {
                                        var prod = nonIntProdArray[zzzz];
                                        var done = false;
                                        if (!done && prod.benefitPlanType && prod.benefitPlanType.toLowerCase() && prod.benefitPlanType.toLowerCase() == "medical") {
                                            // Found a medical plan. We want it to behave like an integrated plan, but ONLY with these ag products
                                            // Lets remove the medical product from the nonInt group, and add it to a fresh integrated list so it doesn't
                                            // conflict with any existing integrated lists
                                            extraIntArray.push(nonIntProdArray.splice(zzzz, 1)[0]);
                                            extraIntArray = extraIntArray.concat(skippedAgProducts);
                                            done = true;
                                            finished = true;
                                        }
                                    }
                                }
                                if (!finished) {
                                    // There were no medical found anywhere, show this as standalone ag
                                    wellnessProdArray = skippedAgProducts;
                                }
                            }
                            runSortOn(intProdArray);

                            if (extraIntArray.length > 0) {
                                var intArrays = [extraIntArray, intProdArray];
                            } else {
                                var intArrays = [intProdArray];
                            }

                            for (var xxxx = 0; xxxx < intArrays.length; xxxx++) {
                                var intProdArray = intArrays[xxxx];
                                if (intProdArray.length > 0) {

                                    if (intProdArray[0].can === "NC") {
                                        return;
                                    }

                                    var newCard = {
                                        "displayGroupNumber": (valc.idCardEobGroupNumber) ? valc.idCardEobGroupNumber : valc.groupNumber,
                                        "memberName": valb.firstName + " " + valb.lastName,
                                        "memberId": ((valb.alphaPrefix != null) ? valb.alphaPrefix : "") + valc.umi, // check prefix rules. its all up in the air.
                                        "groupNumber": valc.groupNumber,
                                        "clientName": vala.clientName,
                                        "clientId": vala.clientId,
                                        "dob": valb.dob,
                                        "plans": intProdArray,
                                        "firstPlan": "", // 
                                        "iconList": [],
                                        "planPeriod": "",
                                        "placement": 0,
                                        "effectuatedDate": "",
                                        "showDate": true,
                                        "consolidated": valc.consolidatedIdCardIndicator,
                                        "cancelled": false,
                                        "medigapIndicator": valc.medigapIndicator,
                                        "hcrProduct": null
                                    };
                                    runSortOn(newCard.plans);
                                    newCard.memberId = ((intProdArray[0].alphaPrefix != null) ? intProdArray[0].alphaPrefix : "") + valc.umi;

                                    var setPlanPeriod = function(currentProduct) {
                                        var isCurrent = function(policy) {
                                            return (policy.endDate == "" || !policy.endDate) && policy.policyState === "current";
                                        };
                                        var setBenefitBeginDate = function(product) {
                                            if (product.benefitAccumulationStartDate !== "" &&
                                                product.benefitAccumulationStartDate != product.coverageBeginDate) {
                                                return product.benefitAccumulationStartDate;
                                            }
                                            return product.coverageBeginDate;
                                        };
                                        var setBenefitEndDate = function(product) {
                                            if (product.benefitAccumulationEndDate !== "" &&
                                                product.benefitAccumulationEndDate != product.coverageEndDate) {
                                                return product.benefitAccumulationEndDate;
                                            }
                                            return product.coverageEndDate;
                                        };

                                        var beginDate = setBenefitBeginDate(currentProduct);
                                        var endDate = isCurrent(currentProduct.effectDate) ? "Current" : setBenefitEndDate(currentProduct);
                                        return beginDate + " - " + endDate;
                                    };
                                    newCard.planPeriod = setPlanPeriod(intProdArray[0]);
                                    //  
                                    var isContinuous = false;

                                    newCard.firstPlan = (valc.hiosName) ? valc.qhpLevel + "-" + valc.hiosName : intProdArray[0].benefitPlanName;
                                    newCard.placement = intProdArray[0].placement;
                                    newCard.showDate = intProdArray[0].effectDate.showDate;
                                    newCard.effectuatedDate = intProdArray[0].effectDate.effectuatedDate;
                                    newCard.paid = paidState(newCard.effectuatedDate, getServerDate());
                                    newCard.hcrProduct = intProdArray[0].hcrProduct;
                                    // build icon list - get placement value runsort on that
                                    // var earilestDate = null;
                                    //var leastDate = null;
                                    var lobHash = {};
                                    var typeHash = {};
                                    var tempplanPeriod2 = null;
                                    var dtToday = getServerDate();

                                    var cancelledCount = 0;
                                    (newCard.plans || []).forEach(function(intplana, indplana) {

                                        // compare plans to see they are the same except date
                                        // isContinuous is true
                                        // add in for second year.


                                        // now obsolete - date merging
                                        /*var tempBeginDate = new Date(intplana.coverageBeginDate).getTime()
                                        if(earilestDate == null ){
                                            earilestDate = tempBeginDate
                                        } else  if (earilestDate > tempBeginDate){
                                            earilestDate = tempBeginDate;
                                        }
                                        //
                                        var tempEndDate = new Date(intplana.coverageEndDate).getTime()
                                        if(leastDate == null ){
                                            leastDate = tempEndDate;
                                        } else  if (leastDate < tempEndDate){
                                            leastDate = tempEndDate;
                                        }*/


                                        // This line below is checking the benefitPlanType, and if the same benefitPlanType has already occured
                                        // then it is false, and the plan is skipped
                                        //
                                        // However, there are instances where multiple LOB's are integrated, but also have the same benefitPlanType
                                        // Changing benefitPlanType to lob
                                        // if(!lobHash[intplana.benefitPlanType.toString()]) {

                                        if (intplana.lob.toLowerCase() == "ag" || !lobHash[intplana.lob.toString()]) {
                                            // new Lob, push it to the card list, but only if the benefitType hasn't been seen before
                                            if (!typeHash[intplana.benefitPlanType.toString()]) {

                                                intplana.clientId = vala.clientId;

                                                intplana.groupNumber = newCard.groupNumber;
                                                newCard.iconList.push({
                                                    "plan": (intplana.benefitPlanType == "Drug") ? "Prescription Drug" : intplana.benefitPlanType,
                                                    "icon": getPlanIcon(intplana.benefitPlanType),
                                                    //"date":intplana.coverageBeginDate+" "+ intplana.coverageEndDate,
                                                    "placement": getPlanValue(intplana.benefitPlanType),
                                                    "can": intplana.can
                                                });
                                                /*                                        var dtCancelDate = new Date(intplana.coverageCancelDate);
                                                                                        if((intplana.can != false) && (dtCancelDate > dtToday)){
                                                                                           newCard.cancelled = true;
                                                                                        }*/
                                                if (intplana.can != false) {
                                                    var dtCancelDate = new Date(intplana.can);
                                                    if (dtCancelDate < dtToday) {
                                                        // newCard.cancelled = true ;
                                                        cancelledCount++;
                                                    }
                                                }
                                                newCard.placement = newCard.iconList[0].placement;
                                                typeHash[intplana.benefitPlanType.toString()] = true;
                                                lobHash[intplana.lob.toString()] = true;
                                            }

                                        } else {
                                            //
                                            isContinuous = true;

                                            //isContinuous = true;
                                            tempplanPeriod2 = intplana.coverageBeginDate + " - " + intplana.coverageEndDate;
                                        }

                                    });
                                    if (cancelledCount >= newCard.plans.length) {
                                        newCard.cancelled = true;
                                    }
                                    /*if(getFilterState() == "past"){
                                        var newStartDate = btsDate.formatDate( new Date(earilestDate));
                                        var newEndDate = btsDate.formatDate( new Date(leastDate));
                                        newCard.planPeriod = newStartDate+" - "+newEndDate;
                                    }*/

                                    var ncpLen = newCard.plans.length;
                                    var ncpCount = 0;
                                    /*arrayFunctions || []).forEach(newCard.plans,function(ncp,indncp){
                                        if(ncp.can){
                                            ncpCount++
                                        }
                                    });*/


                                    // not going to run sort here since i ran it on plans above
                                    if (filterState == "current") {
                                        // if( ncpCount < ncpLen){
                                        valb.cards.push(newCard);
                                        if (isContinuous) {
                                            var dupOnce = angular.copy(newCard);
                                            dupOnce.planPeriod = tempplanPeriod2; //"second";
                                            valb.cards.push(dupOnce);
                                        }
                                        //}
                                    } else { // if(filterState == "past"){
                                        valb.cards.push(newCard);
                                        if (isContinuous) {
                                            var dupOnce = angular.copy(newCard);
                                            dupOnce.planPeriod = tempplanPeriod2; //"second";
                                            valb.cards.push(dupOnce);
                                        }
                                    }
                                }
                            }
                            // }

                            // for (var lmn = 0; lmn < nonIntArrays.length; lmn++) {
                            //     var nonIntProdArray = nonIntArrays[lmn];
                            if (nonIntProdArray.length > 0) {
                                (nonIntProdArray || []).forEach(function(nipa, nipaInt) {

                                    var newCard = {

                                        "displayGroupNumber": (valc.idCardEobGroupNumber) ? valc.idCardEobGroupNumber : valc.groupNumber,
                                        "memberName": valb.firstName + " " + valb.lastName,
                                        "memberId": ((nipa.alphaPrefix != null) ? nipa.alphaPrefix : "") + valc.umi,
                                        "groupNumber": valc.groupNumber,
                                        "clientName": vala.clientName,
                                        "dob": valb.dob,
                                        "plans": [nipa], // run sort of plans before plan period
                                        "firstPlan": "",
                                        "iconList": [],
                                        "planPeriod": "",
                                        "startDate": "",
                                        "placement": 0,
                                        "effectuatedDate": "",
                                        "showDate": true,
                                        "consolidated": valc.consolidatedIdCardIndicator,
                                        "cancelled": false,
                                        "medigapIndicator": valc.medigapIndicator,
                                        "hcrProduct": null
                                    };
                                    runSortOn(newCard.plans);
                                    newCard.startDate = nonIntProdArray[nipaInt].effectDate.beginDate;
                                    newCard.planPeriod = nonIntProdArray[nipaInt].effectDate.beginDate + " - " + (((nonIntProdArray[nipaInt].effectDate.endDate == "" || !nonIntProdArray[nipaInt].effectDate.endDate) && (nonIntProdArray[nipaInt].effectDate.policyState == "current")) ? "Current" : nonIntProdArray[nipaInt].effectDate.endDate);
                                    newCard.firstPlan = (valc.hiosName) ? valc.qhpLevel + "-" + valc.hiosName : nonIntProdArray[nipaInt].benefitPlanName;
                                    if (nonIntProdArray[nipaInt].lob.toLowerCase() == "ag") {
                                        newCard.firstPlan = nonIntProdArray[nipaInt].benefitPlanName;
                                    }
                                    newCard.placement = nonIntProdArray[nipaInt].placement;
                                    newCard.showDate = nonIntProdArray[nipaInt].effectDate.showDate;
                                    newCard.effectuatedDate = nonIntProdArray[nipaInt].effectDate.effectuatedDate;
                                    newCard.paid = paidState(newCard.effectuatedDate, getServerDate());
                                    newCard.hcrProduct = nonIntProdArray[nipaInt].hcrProduct;

                                    var cancelledCount = 0;
                                    (newCard.plans || []).forEach(function(intplana, indplana) {
                                        intplana.clientId = vala.clientId;

                                        intplana.groupNumber = newCard.groupNumber;
                                        newCard.iconList.push({
                                            "plan": (intplana.benefitPlanType == "Drug") ? "Prescription Drug" : intplana.benefitPlanType,
                                            "icon": getPlanIcon(intplana.benefitPlanType),
                                            "placement": getPlanValue(intplana.benefitPlanType),
                                            "can": intplana.can
                                        });

                                        if (intplana.can != false) {
                                            var dtCancelDate = new Date(intplana.can);
                                            if (dtCancelDate < dtToday) {
                                                // newCard.cancelled = true ;
                                                cancelledCount++;
                                            }
                                        }

                                    });
                                    if (cancelledCount >= newCard.plans.length) {
                                        newCard.cancelled = true;
                                    }
                                    newCard.placement = newCard.iconList[0].placement;


                                    var ncpLen = newCard.plans.length;
                                    var ncpCount = 0;
                                    /*arrayFunctions || []).forEach(newCard.plans,function(ncp,indncp){
                                        if(ncp.can){
                                            ncpCount++
                                        }

                                    });*/
                                    // not going to run sort here since i ran it on plans above
                                    if (filterState == "current") {
                                        // if( ncpCount < ncpLen){
                                        nonIntCards.push(newCard);
                                        //}
                                    } else {
                                        nonIntCards.push(newCard);
                                    }
                                });

                                // outdated - can't use this since dates can NOT be provided now... 
                                /*nonIntCards,function(nic || []).forEach(nicInt){
                                    nic.placement -= (new Date(nic.startDate).getTime())
                                });*/
                                (nonIntCards || []).forEach(function(nic1, nic1Int) {
                                    valb.cards.push(nic1);
                                });
                                runSortOn(valb.cards);
                            }

                            // if group/products have  intcovind true
                            // add them to the same card
                            // if they are seperate make a new push... 
                            // sort products on card
                            // card effect date from first product on card 
                            // new card icon list 

                            //integratedCoverageIndicator: "true"


                            if (wellnessProdArray.length > 0) {

                                var newCard = {
                                    "displayGroupNumber": (valc.idCardEobGroupNumber) ? valc.idCardEobGroupNumber : valc.groupNumber,
                                    "memberName": valb.firstName + " " + valb.lastName,
                                    "memberId": ((valb.alphaPrefix != null) ? valb.alphaPrefix : "") + valc.umi, // check prefix rules. its all up in the air.
                                    "groupNumber": valc.groupNumber,
                                    "clientName": vala.clientName,
                                    "clientId": vala.clientId,
                                    "dob": valb.dob,
                                    "plans": wellnessProdArray,
                                    "firstPlan": "", // 
                                    "iconList": [],
                                    "planPeriod": "",
                                    "placement": 0,
                                    "effectuatedDate": "",
                                    "showDate": true,
                                    "consolidated": valc.consolidatedIdCardIndicator,
                                    "cancelled": false,
                                    "medigapIndicator": valc.medigapIndicator,
                                    "hcrProduct": null
                                };
                                runSortOn(newCard.plans);
                                newCard.memberId = ((wellnessProdArray[0].alphaPrefix != null) ? wellnessProdArray[0].alphaPrefix : "") + valc.umi;
                                newCard.planPeriod = wellnessProdArray[0].effectDate.beginDate + " - " + (((wellnessProdArray[0].effectDate.endDate == "" || !wellnessProdArray[0].effectDate.endDate) && (wellnessProdArray[0].effectDate.policyState == "current")) ? "Current" : wellnessProdArray[0].effectDate.endDate);
                                //  
                                var isContinuous = false;

                                newCard.firstPlan = 'Services';
                                newCard.orderOnly = true;
                                newCard.placement = wellnessProdArray[0].placement;
                                newCard.showDate = wellnessProdArray[0].effectDate.showDate;
                                newCard.effectuatedDate = wellnessProdArray[0].effectDate.effectuatedDate;
                                newCard.paid = paidState(newCard.effectuatedDate, getServerDate());
                                newCard.hcrProduct = wellnessProdArray[0].hcrProduct;
                                // build icon list - get placement value runsort on that
                                // var earilestDate = null;
                                //var leastDate = null;
                                var lobHash = {};
                                var typeHash = {};
                                var tempplanPeriod2 = null;
                                var dtToday = getServerDate();

                                var cancelledCount = 0;
                                (newCard.plans || []).forEach(function(intplana, indplana) {

                                    // compare plans to see they are the same except date
                                    // isContinuous is true
                                    // add in for second year.


                                    // now obsolete - date merging
                                    /*var tempBeginDate = new Date(intplana.coverageBeginDate).getTime()
                                    if(earilestDate == null ){
                                        earilestDate = tempBeginDate
                                    } else  if (earilestDate > tempBeginDate){
                                        earilestDate = tempBeginDate;
                                    }
                                    //
                                    var tempEndDate = new Date(intplana.coverageEndDate).getTime()
                                    if(leastDate == null ){
                                        leastDate = tempEndDate;
                                    } else  if (leastDate < tempEndDate){
                                        leastDate = tempEndDate;
                                    }*/


                                    // This line below is checking the benefitPlanType, and if the same benefitPlanType has already occured
                                    // then it is false, and the plan is skipped
                                    //
                                    // However, there are instances where multiple LOB's are integrated, but also have the same benefitPlanType
                                    // Changing benefitPlanType to lob
                                    // if(!lobHash[intplana.benefitPlanType.toString()]) {

                                    if (intplana.lob.toLowerCase() == "ag" || !lobHash[intplana.lob.toString()]) {
                                        // new Lob, push it to the card list, but only if the benefitType hasn't been seen before
                                        if (!typeHash[intplana.benefitPlanType.toString()]) {

                                            intplana.clientId = vala.clientId;

                                            intplana.groupNumber = newCard.groupNumber;
                                            newCard.iconList.push({
                                                "plan": (intplana.benefitPlanType == "Drug") ? "Prescription Drug" : intplana.benefitPlanType,
                                                "icon": getPlanIcon(intplana.benefitPlanType),
                                                //"date":intplana.coverageBeginDate+" "+ intplana.coverageEndDate,
                                                "placement": getPlanValue(intplana.benefitPlanType),
                                                "can": intplana.can
                                            });
                                            /*                                        var dtCancelDate = new Date(intplana.coverageCancelDate);
                                                                                    if((intplana.can != false) && (dtCancelDate > dtToday)){
                                                                                       newCard.cancelled = true;
                                                                                    }*/
                                            if (intplana.can != false) {
                                                var dtCancelDate = new Date(intplana.can);
                                                if (dtCancelDate < dtToday) {
                                                    // newCard.cancelled = true ;
                                                    cancelledCount++;
                                                }
                                            }
                                            newCard.placement = newCard.iconList[0].placement;
                                            typeHash[intplana.benefitPlanType.toString()] = true;
                                            lobHash[intplana.lob.toString()] = true;
                                        }

                                    } else {
                                        //
                                        isContinuous = true;

                                        //isContinuous = true;
                                        tempplanPeriod2 = intplana.coverageBeginDate + " - " + intplana.coverageEndDate;
                                    }

                                });
                                if (cancelledCount >= newCard.plans.length) {
                                    newCard.cancelled = true;
                                }
                                /*if(getFilterState() == "past"){
                                    var newStartDate = btsDate.formatDate( new Date(earilestDate));
                                    var newEndDate = btsDate.formatDate( new Date(leastDate));
                                    newCard.planPeriod = newStartDate+" - "+newEndDate;
                                }*/

                                var ncpLen = newCard.plans.length;
                                var ncpCount = 0;
                                /*arrayFunctions || []).forEach(newCard.plans,function(ncp,indncp){
                                    if(ncp.can){
                                        ncpCount++
                                    }
                                });*/


                                // not going to run sort here since i ran it on plans above
                                if (filterState == "current") {
                                    // if( ncpCount < ncpLen){
                                    valb.cards.push(newCard);
                                    if (isContinuous) {
                                        var dupOnce = angular.copy(newCard);
                                        dupOnce.planPeriod = tempplanPeriod2; //"second";
                                        valb.cards.push(dupOnce);
                                    }
                                    //}
                                } else { // if(filterState == "past"){
                                    valb.cards.push(newCard);
                                    if (isContinuous) {
                                        var dupOnce = angular.copy(newCard);
                                        dupOnce.planPeriod = tempplanPeriod2; //"second";
                                        valb.cards.push(dupOnce);
                                    }
                                }
                            }


                        });

                        runSortOn(valb.cards);

                        //sort cards here...

                    });
                    var tempMemberCount = vala.members.length;
                    var newMemberCount = 0;
                    var membersToRemove = [];
                    (vala.members || []).forEach(function(checkb, checkindb) {
                        if (checkb.cards.length <= 0) {
                            newMemberCount++;
                            membersToRemove.push(checkindb);
                        }
                    });
                    if (tempMemberCount == newMemberCount) {
                        vala.showClient = false;
                        vala.members = [];
                    } else {
                        membersToRemove.reverse();
                        (membersToRemove || []).forEach(function(removeaaa, removeindaaa) {
                            vala.members.splice(removeaaa, 1);
                        });
                        if (vala.members && firstmember) {
                            // vala.members[0].drawerOpen = "open"
                            firstmember = false;
                        }
                    }

                });


                var clientsToRemove = [];
                (list.clientList || []).forEach(function(checkc, checkindc) {
                    if (checkc.members && checkc.members.length <= 0) {
                        clientsToRemove.push(checkindc);
                    }
                });
                clientsToRemove.reverse();
                (clientsToRemove || []).forEach(function(removea, removeinda) {
                    list.clientList.splice(removea, 1);
                });
                (list.clientList || []).forEach(function(checkd, checkindd) {
                    getMemberDOBValue(checkd.members);

                });

                (list.clientList || []).forEach(function(cl, clInt) {
                    if (cl.members[0] && cl.members[0].cards[0] && cl.members[0].cards[0].iconList[0] && cl.members[0].cards[0].iconList[0].plan) {
                        cl.placement = getPlanValue(cl.members[0].cards[0].iconList[0].plan);
                    } else {
                        cl.placement = 4;
                    }


                });
                /* if(!firstMemberReachedFlag){
                                    firstMemberReachedFlag = true;
                                    valb.drawerOpen = "open";
                                }else{
                                    valb.drawerOpen = "close";
                                }*/
                runSortOn(list.clientList);
                if (list && list.clientList[0] && list.clientList[0].members[0] && list.clientList[0].members[0].drawerOpen) {
                    list.clientList[0].members[0].drawerOpen = true;
                }

                // if no clients remove them here.

                var cState;
                switch (that.getFilterState()) {
                    case "past":
                        cState = 0;
                        break;
                    case "current":
                        cState = 1;
                        break;
                    case "future":
                        cState = 2;
                        break;
                }

                (list.clientList || []).forEach(function(cl, clInt) {
                    (cl.members || []).forEach(function(memb, membInt) {
                        (memb.cards || []).forEach(function(card, cardInt) {
                            card.id = cState + "-" + clInt + "-" + membInt + "-" + cardInt;
                        });
                    });
                });

            };


            /**clients - returns a list of just the clients with their basic information for a ums return.*/
            var getClients = function() {
                var cloneData = angular.copy(umsOriginal);
                var returnObj = [];

                (cloneData.clientList || []).forEach(function(val, ind) {
                    var tempClient = {
                        "clientId": val.clientId || null,
                        "clientNumber": val.clientNumber || null,
                        "clientName": val.clientName || null,
                        "enrollmentSourceCode": val.enrollmentSourceCode || null,
                        "spendingAccountBlackoutIndicator": val.spendingAccountBlackoutIndicator || null,
                        "spendingAccountBlackoutStartDate": val.spendingAccountBlackoutstartdate || null,
                        "spendingAccountBlackoutEndDate": val.spendingAccountBlackoutenddate || null,
                        "groupList": val.groupList || null // I want to remove this at some point.
                    };
                    returnObj.push(tempClient);
                });
                return returnObj;
            };

            /**clientProductList - returns list of products for a client
            the passed in argument is a zero based int of the clients */
            var clientProductList = function(clientInt) {
                // returns full list of products... 
                // if int doesnt' exist - default it to 0
                // go through fullgrouplist above
                // go through productlist in each group
                // eliminate duplicates
                var fullProductList = [],

                    getClientGroupList = clientGroupList(clientInt);

                (getClientGroupList || []).forEach(function(vala, inda) {
                    // go through fullgrouplist above
                    (vala.productList || []).forEach(function(valb, indb) {
                        // go through productlist in each group
                        valb.clientNumber = vala.clientNumber;
                        valb.clientId = vala.clientId;
                        valb.groupNumber = vala.groupNumber;
                        fullProductList.push(valb);
                    });
                });
                // eliminate duplicates
                var cleanedList = removeDuplicateProducts(fullProductList);
                return cleanedList;
            };

            /**groupProductList - returns list of products for a group in a client
            the passed in arguments are a zero based int of the clients
            and a zero based int for the group in that client.*/
            var groupProductList = function(clientInt, groupInt) {
                //product list - group
                //get the client - get the group in the client
                //getfullGroupList = clientGroupList(clientInt)[groupInt];
                var groupProductList = [],
                    tempProductNumberListForComparison = [],
                    getClientGroupList = clientGroupList(clientInt);

                getClientGroupList = getClientGroupList[groupInt] || getClientGroupList[0];

                (getClientGroupList.productList || []).forEach(function(vala, inda) {
                    // go through productlist in each group
                    groupProductList.push(vala);
                });

                // eliminate duplicates
                var cleanedList = removeDuplicateProducts(groupProductList);
                return cleanedList;
            };


            /** removeDuplicateProducts - removes duplicate products in an array. used with functions above.*/
            var removeDuplicateProducts = function(list) {
                // console.log(0);
                var cleanedList = [],
                    firstRun = true;
                (list || []).forEach(function(vala, inda) {
                    var firstObj = {
                            "pn": vala.productNumber,
                            "begin": vala.coverageBeginDate,
                            "end": vala.coverageEndDate,
                            "clientNumber": vala.clientNumber,
                            "groupNumber": vala.groupNumber
                        },
                        check = false;

                    (cleanedList || []).forEach(function(valb, indb) {
                        if (inda != indb && check == false) {
                            var secondObj = {
                                "pn": valb.productNumber,
                                "begin": valb.coverageBeginDate,
                                "end": valb.coverageEndDate,
                                "clientNumber": valb.clientNumber,
                                "groupNumber": valb.groupNumber
                            };
                            if (angular.equals(firstObj, secondObj)) {
                                check = true;
                            }
                            if (firstRun) {
                                check = false;
                                firstRun = false;
                            }
                        }
                    });
                    if (!check) {
                        cleanedList.push(vala);
                    }
                });
                return cleanedList;
            };

            /** removeDuplicatesMembers - when building the returns at the top I am grabbing all members in every product in every group and in every client
            This function then goes through those lists and finds duplicate names and removes thems.*/
            var removeDuplicatesMembers = function(list) {
                var self = this;
                var cleanedList = [],
                    newList = angular.copy(list),
                    firstRun = true,
                    memberHash = {};

                (list || []).forEach(function(member) {
                    var memberNameKey = getMemberNameKey(member) + member.coverageEffectiveDate;

                    if (!memberHash[memberNameKey]) {
                        memberHash[memberNameKey] = true;
                        cleanedList.push(member);
                    }

                });
                return cleanedList;
            };
            var removeDuplicatesMembersWithoutDates = function(list) {
                var self = this;
                var cleanedList = [],
                    newList = angular.copy(list),
                    firstRun = true,
                    memberHash = {};

                (list || []).forEach(function(member) {
                    var memberNameKey = getMemberNameKey(member);

                    if (!memberHash[memberNameKey]) {
                        memberHash[memberNameKey] = true;
                        cleanedList.push(member);
                    }

                });
                return cleanedList;
            };
            /**getMemberNameKey from user.js - builds out a unique name for a hashmap - 
            mainly used to removeDuplicatesMembers  */
            var getMemberNameKey = function(member) {
                return toCamelCase(member.firstName) + toCamelCase(member.lastName) + member.suffix + member.dob;
            };

            //TG : trying to clean and stablise umsParse object.
            var umsParse = {
                /** setFilterState - looks for and sets the filterstate to
                    'all' // to be removed
                    'current'
                    'future'
                    'past'
                */
                setFilterState: function(state) {
                    /*filterState = "current"*/
                    if (state == "current" || state == "future" || state == "past") {
                        filterState = state;
                    } else {
                        //console.log("invalid filter state set in umsparser",state);
                    }
                },
                /**getFilterState - returns filterstate*/
                getFilterState: function() {
                    return filterState;
                },
                /**baseInformation - This returns the information at the top level of the ums reply.
                it does not include any lists further down the the ums reply*/
                baseInformation: function() {
                    var cloneData = angular.copy(umsOriginal);
                    var returnObj = {
                        "brand": brand.current.sharedBrandCode.toLowerCase() || null, //cloneData.brand || null,
                        "umi": cloneData.umi || null,
                        "agreementId": cloneData.agreementId || null,
                        "bvUserId": cloneData.bvUserId || null,
                        "registrationDate": cloneData.registrationDate || null,
                        "lastActivitySummaryVisitDate": cloneData.lastActivitySummaryVisitDate || null,
                        "lastClaimPaymentVisitDate": cloneData.lastClaimPaymentVisitDate || null,
                        "lastPlanActivityVisitDate": cloneData.lastPlanActivityVisitDate || null,
                        "lastEdMaterialVisitDate": cloneData.lastEdMaterialVisitDate || null,
                        "lastMessageCenterVisitDate": cloneData.lastMessageCenterVisitDate || null,
                        "mhsTermsConditionsCode": cloneData.mhsTermsConditionsCode || null,
                        "emktUserType": cloneData.emktUserType || null,
                        "emktUserName": cloneData.emktUserName || null,
                        "emktPortal": cloneData.emktPortal || null,
                        "emktBrand": cloneData.emktBrand || null
                    };
                    return returnObj;
                },
                /**clients - returns a list of just the clients with their basic information for a ums return.*/
                clients: function() {
                    return getClients();
                },
                /**fullGroupList - returns full list of groups  across clients*/
                fullGroupList: function() {
                    // returns full list of groups 
                    // eliminates duplicates
                    var fullGroupList = [],
                        tempGroupNumberListForComparison = [],
                        clientList = this.clients();

                    (clientList || []).forEach(function(val, ind) {
                        (val.groupList || []).forEach(function(valb, indb) {
                            if (tempGroupNumberListForComparison.indexOf(valb.groupNumber) == -1) {
                                tempGroupNumberListForComparison.push(valb.groupNumber);
                                valb.clientNumber = val.clientNumber;
                                valb.clientId = val.clientId;
                                fullGroupList.push(valb);
                            }
                        });
                    });

                    return fullGroupList;
                },
                /**fullProductList - returns full list of products*/
                fullProductList: function() {
                    // returns full list of products... 
                    // go through fullgrouplist above
                    // go through productlist in each group

                    var self = this,
                        fullProductList = [],
                        firstRun = true, //firstRun
                        tempProductNumberListForComparison = [],
                        getfullGroupList = this.fullGroupList();

                    (getfullGroupList || []).forEach(function(vala, inda) {
                        // go through fullgrouplist above
                        (vala.productList || []).forEach(function(valb, indb) {
                            valb.clientNumber = vala.clientNumber;
                            valb.clientId = vala.clientId;
                            valb.groupNumber = vala.groupNumber;
                            fullProductList.push(valb);
                        });
                    });

                    // eliminate duplicates
                    var cleanedList = removeDuplicateProducts(fullProductList);


                    return cleanedList;
                },



                /**memberProductList - never continued development of this hence planning to remove. also removed memberGrouplst*/
                //memberProductList : function(whom){
                //not gonna work this just yet - need member stuff figured first.
                //},

                /**fullMemberList - returns full list of members in the ums return*/
                fullMemberList: function() { // unique... 
                    var getAllProducts = this.fullProductList();
                    var memberList = [];
                    var self = this;
                    (getAllProducts || []).forEach(function(vala, inda) {
                        (vala.memberList || []).forEach(function(valb, indb) {
                            var uniqueMemberObj = {
                                'showDOB': false,
                                'clientNumber': vala.clientNumber,
                                'groupNumber': vala.groupNumber,
                                'ecId': valb.ecId,
                                'gender': valb.gender,
                                'firstName': toCamelCase(valb.contact.firstName),
                                'middleName': toCamelCase(valb.contact.middleName),
                                'lastName': toCamelCase(valb.contact.lastName),
                                'suffix': valb.contact.suffix ? toCamelCase(valb.contact.suffix) : "",
                                'dob': valb.contact.birthDate,
                                'covCancellationDate': valb.coverageCancellationDate,
                                'coverageEffectiveDate': valb.coverageEffectiveDate,
                                'pinNumber': valb.pinNumber,
                                'relationship': valb.relationship,
                                'relationshipCode': valb.relationshipCode,
                                'placement': self.getMemberValue(valb.relationship),
                                'ciid': valb.coveredIndividualId,
                                'productIdx': inda,
                                'uniqueName': self.getUniqueMemberName(valb.contact.firstName, valb.contact.birthDate)
                            };
                            // removed unique name
                            memberList.push(uniqueMemberObj);
                        });
                    });
                    runSortOn(memberList);
                    //eliminates duplicates
                    var cleanedList = removeDuplicatesMembers(memberList);
                    return cleanedList;
                },
                /**clientMemberList - returns list of members for a client the passed in argument is a zero based int of the clients */
                clientMemberList: function(clientInt) {
                    window.ums = this;
                    var getAllProducts = clientProductList(clientInt);
                    var memberList = [];
                    var self = this;
                    (getAllProducts || []).forEach(function(vala, inda) {
                        (vala.memberList || []).forEach(function(valb, indb) {
                            var uniqueMemberObj = {
                                'ecId': valb.ecId,
                                'firstName': toCamelCase(valb.contact.firstName),
                                'lastName': toCamelCase(valb.contact.lastName),
                                'suffix': valb.contact.suffix ? toCamelCase(valb.contact.suffix) : "",
                                'dob': valb.contact.birthDate,
                                'covCancellationDate': valb.coverageCancellationDate,
                                'coverageEffectiveDate': valb.coverageEffectiveDate,
                                'pinNumber': valb.pinNumber,
                                'relationship': valb.relationship,
                                'relationshipCode': valb.relationshipCode,
                                'ciid': valb.coveredIndividualId,
                                'uniqueName': self.getUniqueMemberName(valb.contact.firstName, valb.contact.birthDate)
                            };
                            // removed unique name
                            memberList.push(uniqueMemberObj);
                        });
                    });
                    //eliminates duplicates
                    var cleanedList = removeDuplicatesMembers(memberList);
                    return cleanedList;
                },
                /**groupMemberList - returns list of members for a group in a client
                the passed in arguments are a zero based int of the clients
                and a zero based int for the group in that client.*/
                groupMemberList: function(clientInt, groupInt) {
                    var getAllProducts = groupProductList(clientInt, groupInt);
                    var memberList = [];
                    var self = this;
                    (getAllProducts || []).forEach(function(vala, inda) {
                        (vala.memberList || []).forEach(function(valb, indb) {
                            var uniqueMemberObj = {
                                'ecId': valb.ecId,
                                'firstName': toCamelCase(valb.contact.firstName),
                                'lastName': toCamelCase(valb.contact.lastName),
                                'suffix': valb.contact.suffix ? toCamelCase(valb.contact.suffix) : "",
                                'dob': valb.contact.birthDate,
                                // 'covCancellationDate': valb.coverageCancellationDate,
                                'coverageEffectiveDate': valb.coverageEffectiveDate,
                                'pinNumber': valb.pinNumber,
                                'relationship': valb.relationship,
                                'relationshipCode': valb.relationshipCode,
                                'ciid': valb.coveredIndividualId,
                                'uniqueName': self.getUniqueMemberName(valb.contact.firstName, valb.contact.birthDate)
                            };
                            // removed unique name
                            memberList.push(uniqueMemberObj);
                        });
                    });
                    //eliminates duplicates
                    var cleanedList = removeDuplicatesMembers(memberList);
                    return cleanedList;
                },
                /** This is where I begain to reverse out the information based on a member*/

                /** memberListOfClients - this is a full list of members for the return with an array
                of clients each of those members is part of*/
                memberListOfClients: function() {
                    var self = this,
                        fullMemList = this.fullMemberList(),
                        clientList = this.clients();
                    (fullMemList || []).forEach(function(vala, inda) {
                        (clientList || []).forEach(function(valb, indb) {
                            if (vala.clientNumber == valb.clientNumber) {
                                vala.client = valb;
                            }
                        });
                    });
                    return fullMemList;
                },
                /** memberListOfGroups - this is a full list of members for the return with an array
                of groups each of those members is part of*/
                memberListOfGroups: function(c) {
                    // go through member list one by one
                    // for each member go through grouplist to see if they are in the groups list
                    // push that into they 
                    var self = this,
                        fullMemList = this.clientMemberList(c), //(c)?this.clientMemberList(0):this.fullMemberList(),
                        fullGroupList = this.fullGroupList();



                    (fullMemList || []).forEach(function(vala, inda) {
                        var valaUniqueMemberObj = {
                            'ecId': vala.ecId,
                            'firstName': vala.firstName,
                            'lastName': vala.lastName,
                            'suffix': vala.suffix,
                            'dob': vala.dob,
                            //'covCancellationDate': vala.covCancellationDate,
                            // 'coverageEffectiveDate': vala.coverageEffectiveDate,
                            'pinNumber': vala.pinNumber,
                            'relationship': vala.relationship,
                            'relationshipCode': vala.relationshipCode,
                            'ciid': vala.ciid,
                            'uniqueName': vala.uniqueName
                        };
                        vala.groupList = [];
                        (fullGroupList || []).forEach(function(valb, indb) {
                            var foundMember = false;
                            (valb.productList || []).forEach(function(valc, indc) {
                                if (!foundMember) {
                                    (valc.memberList || []).forEach(function(vald, indd) {
                                        var valdUniqueMemberObj = {
                                            'ecId': vald.ecId,
                                            'firstName': toCamelCase(vald.contact.firstName),
                                            'lastName': toCamelCase(vald.contact.lastName),
                                            'suffix': vald.contact.suffix ? toCamelCase(vald.contact.suffix) : "",
                                            'dob': vald.contact.birthDate,
                                            //'covCancellationDate': vald.coverageCancellationDate,
                                            // 'coverageEffectiveDate': vald.coverageEffectiveDate,
                                            'pinNumber': vald.pinNumber,
                                            'relationship': vald.relationship,
                                            'relationshipCode': vald.relationshipCode,
                                            'ciid': vald.coveredIndividualId,
                                            'uniqueName': self.getUniqueMemberName(vald.contact.firstName, vald.contact.birthDate)
                                        };
                                        var compare = angular.equals(valaUniqueMemberObj, valdUniqueMemberObj);

                                        if (compare) {
                                            vala.groupList.push(valb);
                                            foundMember = true;
                                        }
                                    });
                                }
                            });
                        });
                    });
                    return fullMemList;
                },
                /** memberListOfProducts - this is a full list of members for the return with an array of products each of those members*/
                memberListOfProducts: function(c) {
                    var self = this,
                        fullMemList = this.fullMemberList(),
                        fullProductList = this.fullProductList();

                    (fullMemList || []).forEach(function(vala, inda) {
                        var valaUniqueMemberObj = {
                            'ecId': vala.ecId,
                            'firstName': vala.firstName,
                            'lastName': vala.lastName,
                            'suffix': vala.suffix,
                            'dob': vala.dob,
                            //'covCancellationDate': vala.covCancellationDate,
                            // 'coverageEffectiveDate': vala.coverageEffectiveDate,
                            'pinNumber': vala.pinNumber,
                            'relationship': vala.relationship,
                            'relationshipCode': vala.relationshipCode,
                            /*'ciid' : vala.ciid,*/
                            'uniqueName': vala.uniqueName
                        };
                        vala.productList = [];

                        (fullProductList || []).forEach(function(valb, indb) {
                            var foundMember = false;

                            (valb.memberList || []).forEach(function(vald, indc) {
                                if (!foundMember) {
                                    var valdUniqueMemberObj = {
                                        'ecId': vald.ecId,
                                        'firstName': toCamelCase(vald.contact.firstName),
                                        'lastName': toCamelCase(vald.contact.lastName),
                                        'suffix': vald.contact.suffix ? toCamelCase(vald.contact.suffix) : "",
                                        'dob': vald.contact.birthDate,
                                        //'covCancellationDate': vald.coverageCancellationDate,
                                        // 'coverageEffectiveDate': vald.coverageEffectiveDate,
                                        'pinNumber': vald.pinNumber,
                                        'relationship': vald.relationship,
                                        'relationshipCode': vald.relationshipCode,
                                        /* 'ciid' : vald.coveredIndividualId,*/
                                        'uniqueName': self.getUniqueMemberName(vald.contact.firstName, vald.contact.birthDate)
                                    };
                                    var compare = angular.equals(valaUniqueMemberObj, valdUniqueMemberObj);

                                    if (compare) {
                                        vala.productList.push(valb);
                                        foundMember = true;
                                    }
                                }
                            });
                        });
                    });
                    return fullMemList;
                },
                memberListHasProductsPerFilter: function(list) {
                    var self = this;
                    var m = this.memberListOfProducts();
                    (m || []).forEach(function(vala, inda) {
                        vala.productTypes = [];
                        vala.productTimes = [];
                        var clone = angular.copy(vala.productList);
                        (clone || []).forEach(function(valb, indb) {
                            vala.productTypes.push(valb.benefitPlanType);
                            valb.effectDate = {
                                'beginDate': valb.coverageBeginDate,
                                'endDate': valb.coverageEndDate,
                                'policyState': self.getPolicyState(valb.coverageBeginDate, valb.coverageEndDate, true, getServerDate(), valb.coverageConBeginDate, valb.benefitPlanType, valb.integratedCoverageIndicator) // serverDate
                            };
                            vala.productTimes.push(valb.effectDate.policyState);
                        });
                    });
                    return m;
                },



                ////////////////////////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////////////////////////
                /**AS = account settings. member information screen build
                This calling this takes the ums return and rebuilds it for use in the MER 
                membership information screen. (This does need to be rebuilt some again)
                the structure returned is 
                clients
                    members
                        groups 
                            products
                elements are sorted along the way other elements are added in. 
                There is also a timefilter called before the final return
                ** i want to remove those to the app
                */
                ASMemberInfoFeed: function() {
                    var self = this;
                    var fullresponse = this.baseInformation();
                    fullresponse.clientList = this.clients();
                    var holdmemberreferences = [];
                    var firstMemberReachedFlag = false;
                    (fullresponse.clientList || []).forEach(function(vala, inda) {
                        // for each client get hte members ... get members with groups populated
                        vala.members = self.clientMemberList(inda);
                        // added in values used in page - used to match html design.
                        vala.showClient = true;

                        var mg = self.memberListOfGroups(inda);
                        var mp = self.memberListOfProducts();
                        // get groups and match up the members with their group lists
                        (vala.members || []).forEach(function(valb, indb) {
                            // valb is a member info
                            var valbUniqueMemberObj = {
                                'ecId': valb.ecId,
                                'firstName': valb.firstName,
                                'lastName': valb.lastName,
                                'suffix': valb.suffix,
                                'dob': valb.dob,
                                //'covCancellationDate': valb.covCancellationDate,
                                // 'coverageEffectiveDate': valb.coverageEffectiveDate,
                                'pinNumber': valb.pinNumber,
                                'relationship': valb.relationship,
                                'relationshipCode': valb.relationshipCode,
                                'ciid': valb.ciid,
                                'uniqueName': valb.uniqueName
                            };
                            valb.groups = [];
                            (mg || []).forEach(function(valc, indc) {
                                //if member match push mg.groups
                                var valcUniqueMemberObj = {
                                    'ecId': valc.ecId,
                                    'firstName': valc.firstName,
                                    'lastName': valc.lastName,
                                    'suffix': valc.suffix,
                                    'dob': valc.dob,
                                    //'covCancellationDate': valc.covCancellationDate,
                                    // 'coverageEffectiveDate': valc.coverageEffectiveDate,
                                    'pinNumber': valc.pinNumber,
                                    'relationship': valc.relationship,
                                    'relationshipCode': valc.relationshipCode,
                                    'ciid': valc.ciid,
                                    'uniqueName': valc.uniqueName
                                };

                                var compare = angular.equals(valbUniqueMemberObj, valcUniqueMemberObj);

                                if (compare) {
                                    valb.drawerHeight = 0;

                                    /* if(!firstMemberReachedFlag){
                                         firstMemberReachedFlag = true;
                                         valb.drawerOpen = "open";
                                     }else{
                                         valb.drawerOpen = "close";
                                     }*/
                                    valb.drawerOpen = false;
                                    if(indb == '0' && indc == 0) valb.drawerOpen = true;
                                    valb.iconList = [];

                                    valb.showMember = true;
                                    valb.placement = 0; //getMemberValue(tempmember.relationship);
                                    valb.moduloPlacement = indb;
                                    //valb.showDOB = false;
                                    valb.showMember = true;
                                    valb.viewIDCardLink = "#!/account/view-id-card";
                                    //valb.hios = hios: false  ??? nneed to remove this go into products

                                    valb.groups = valc.groupList;
                                }
                                //                            else
                                //console.log('587, compare is false');                    

                            });
                            (valb.groups || []).forEach(function(vald, indd) {
                                vald.productList = removeDuplicateProducts(vald.productList);

                                //console.log('592, client->members->groups ', vald);                    

                                vald.medigapIndicator = (vald.medigapIndicator === "false") ? false : true;

                                vald.showGroup = true;
                                vald.iconList = [];
                                vald.originalGroupNumber = angular.copy(vald.groupNumber);
                                /*if (vald.idCardEobGroupNumber){

                                    vald.groupNumber = vald.idCardEobGroupNumber
                                }*/
                                vald.productsRemainingFlag = true;
                                vald.productsFirst = [vald.productList[0]] || [];

                                if (vald.productsFirst.length == 1 && vald.hiosName) {
                                    vald.productsFirst[0].benefitPlanName = vald.hiosName;
                                }

                                vald.placement = getPlanValue(vald.productsFirst[0].benefitPlanType); // need to resolve 
                                vald.umi = fullresponse.umi;

                                vald.effectDate = {};
                                vald.effectDate.showDate = false;
                                vald.products = angular.copy(vald.productList);

                                (vald.productList || []).forEach(function(vale, inde) {
                                    //console.log('618, client->members->groups.products ', vale);                    

                                    vale.alphaPrefix = (vale.alphaPrefix != null) ? vale.alphaPrefix : "";
                                    vale.placement = getPlanValue(vale.benefitPlanType);
                                    vale.effectDate = {
                                        'coverageConBeginDate': vale.coverageConBeginDate,
                                        'effectuatedDate': vale.effectuatedDate,
                                        'beginDate': vale.coverageBeginDate,
                                        'endDate': vale.coverageEndDate,
                                        'showDate': (vale.integratedCoverageIndicator == "false" && (vale.benefitPlanType == "Drug" || vale.benefitPlanType == "Prescription Drug" || vale.benefitPlanType == "Vision")) ? false : true,
                                        'policyState': self.getPolicyState(vale.coverageBeginDate, vale.coverageEndDate, true, getServerDate(), vale.coverageConBeginDate, vale.benefitPlanType, vale.integratedCoverageIndicator) // serverDate
                                    };
                                    vald.iconList.push({
                                        "plan": (vale.benefitPlanType == "Drug") ? "Prescription Drug" : vale.benefitPlanType,
                                        "icon": getPlanIcon(vale.benefitPlanType),
                                        "placement": getPlanValue(vale.benefitPlanType)
                                    });
                                });


                                runSortOn(valb.iconList);

                                // is going to be wrong for now
                                vald.effectDate = {
                                    'coverageConBeginDate': vald.productList[0].effectDate.coverageConBeginDate,
                                    'effectuatedDate': vald.productList[0].effectDate.effectuatedDate,
                                    'beginDate': vald.productList[0].effectDate.beginDate,
                                    'endDate': vald.productList[0].effectDate.endDate,
                                    'policyState': vald.productList[0].effectDate.policyState,
                                    //'covCancellationDate': vald.productList[0].effectDate.covCancellationDate,
                                    'showDate': vald.productList[0].effectDate.showDate
                                };
                            });
                            runSortOn(valb.groups);
                        });


                        //need to order members by age - unless subscriber
                        //elf.getDOBShowFlag(vala.members);


                    });

                    //console.log('663, Before calling time filter',  fullresponse);             

                    fullresponse = this.timeFilter(fullresponse);
                    //console.log('666, After calling time filter',  fullresponse);             


                    // loop through clients here ... again... 
                    (fullresponse.clientList || []).forEach(function(vala, inda) {
                        getMemberDOBValue(vala.members);
                        self.getModuloValue(vala.members);

                        (vala.members || []).forEach(function(val2, ind2) {
                            val2.showDOB = false;
                            holdmemberreferences.push(val2);
                        });
                        self.getDOBShowFlag(holdmemberreferences);
                    });
                    // lang.hitch(this, buildCards)(fullresponse);
                    buildCards.bind(this)(fullresponse);
                    return fullresponse;
                },




                ////////////////////////////////////////////////////////////////////////////////////
                ////////////////////////////////////////////////////////////////////////////////////
                /** The below functions are helper for correct returns above.*/
                getPlansForWhen: function() {
                    var self = this,
                        stateArray = ["current", "past", "future"],
                        cs = angular.copy(this.fullProductList()),
                        returnObj = {
                            current: false,
                            past: false,
                            future: false
                        };

                    var oldState = this.getFilterState();
                    (stateArray || []).forEach(function(ps) {
                        self.setFilterState(ps);
                        var tempFeed = self.ASMemberInfoFeed();
                        if (tempFeed && tempFeed.clientList) {
                            (tempFeed.clientList || []).forEach(function(client) {
                                if (client.members) {
                                    (client.members || []).forEach(function(member) {
                                        if (member.groups) {
                                            (member.groups || []).forEach(function(group) {
                                                if (group.products && group.products.length > 0) {
                                                    returnObj[ps] = true;
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                    this.setFilterState(oldState);
                    return returnObj;

                },

                getPortalSelectedClient: function(clients, groupNumber) {
                    var selectedClient = null;
                    for (var i = 0; i < clients.length; i++) {
                        for (var x = 0; x < clients[i].groupList.length; x++) {
                            if (clients[i].groupList[x].groupNumber === groupNumber) {
                                selectedClient = clients[i];
                                break;
                            }
                        }
                        if (selectedClient !== null) {
                            break;
                        }
                    }
                    return selectedClient;
                },

                /*phila needs a method to pass in a group Number and a effective date
                I dont' know as to if i need to show ed's that haven't happened yet or have happened 
                and i dont' know if its just for future or past or current or all or some combo of those....*/
                getPortalSelectedPlan: function(gn, ed) {
                    var gnfromCookie = gn || $cookies.get("mbrGroupNumber"),
                        edfromCookie = ed || $cookies.get("mbrGroupEffectiveDate"),
                        //fpl = angular.copy( this.fullProductList() ),
                        fpl = angular.copy(this.fullGroupList()),
                        redateED = edfromCookie && edfromCookie.substr(0, 2) + "/" + edfromCookie.substr(2, 2) + "/" + edfromCookie.substr(4) || '',
                        returnArray = [];

                    (fpl || []).forEach(function(vala, inta) {
                        vala.beginDate = vala.productList && vala.productList[0] && vala.productList[0].coverageBeginDate;
                        vala.benefitPlanName = vala.productList && vala.productList[0] && vala.productList[0].benefitPlanName;
                        vala.displayGroupNumber = (vala.idCardEobGroupNumber) ? vala.idCardEobGroupNumber : vala.groupNumber;

                        if (vala.groupNumber == gnfromCookie) { //} && vala.coverageBeginDate == redateED ) {
                            returnArray.push(vala);
                        }

                    });

                    return returnArray;
                },
                getSpecificMember: function(memberObj, product, groupNumber, clientNumber) {
                    var self = this;
                    for (var x = 0; x < product.memberList.length; x++) {
                        var uniqueMemberObj1 = {
                            'ecId': product.memberList[x].ecId,
                            'firstName': toCamelCase(product.memberList[x].contact.firstName),
                            'lastName': toCamelCase(product.memberList[x].contact.lastName),
                            'suffix': product.memberList[x].contact.suffix ? toCamelCase(product.memberList[x].contact.suffix) : "",
                            'dob': product.memberList[x].contact.birthDate,
                            'pinNumber': product.memberList[x].pinNumber,
                            'relationship': product.memberList[x].relationship,
                            'relationshipCode': product.memberList[x].relationshipCode,
                            'ciid': product.memberList[x].coveredIndividualId,
                            'uniqueName': self.getUniqueMemberName(product.memberList[x].contact.firstName, product.memberList[x].contact.birthDate)
                        };
                        var uniqueMemberObj2 = {
                            'ecId': memberObj.ecId,
                            'firstName': toCamelCase(memberObj.firstName),
                            'lastName': toCamelCase(memberObj.lastName),
                            'suffix': memberObj.suffix ? toCamelCase(memberObj.suffix) : "",
                            'dob': memberObj.dob,
                            'pinNumber': memberObj.pinNumber,
                            'relationship': memberObj.relationship,
                            'relationshipCode': memberObj.relationshipCode,
                            'ciid': memberObj.ciid,
                            'uniqueName': memberObj.uniqueName
                        };
                        var compare = angular.equals(uniqueMemberObj1, uniqueMemberObj2);
                        if (compare) {
                            return angular.extend({}, memberObj, {
                                coverageEffectiveDate: product.memberList[x].coverageEffectiveDate
                            });
                        }
                    }
                },
                /** timeFilter - this goes through clients>members>groups>products 
                to find products that have 'effectDate.policyState' equal to the filterState.
                and resets the product list for each member to that list.
                */
                timeFilter: function(list) {

                    var self = this;
                    var state = this.getFilterState();
                    // alert(this.getFilterState())
                    // dig into product lists.
                    // rebuild list from what plans have same'state'
                    // others removed. `d
                    (list.clientList || []).forEach(function(vala, inda) {
                        vala.members = angular.copy(vala.members);
                        (vala.members || []).forEach(function(valb, indb) {
                            (valb.groups || []).forEach(function(valc, indc) {
                                var tempproducts = angular.copy(valc.productList);
                                var newproducts = [];
                                // clear iconlist per group... will need moved to card
                                valc.iconList.splice(0, valc.iconList.length);
                                (tempproducts || []).forEach(function(vald, indd) {
                                    var specificMember = self.getSpecificMember(valb, vald);
                                    if (specificMember) {
                                        if ((vald.effectDate.policyState == state) || ((state == "future") && (new Date(specificMember.coverageEffectiveDate) > new Date()))) {
                                            newproducts.push(vald);
                                            // reset icon-list
                                            valc.iconList.push({
                                                "plan": (vald.benefitPlanType == "Drug") ? "Prescription Drug" : vald.benefitPlanType,
                                                "icon": getPlanIcon(vald.benefitPlanType),
                                                "placement": getPlanValue(vald.benefitPlanType)
                                            });
                                        }
                                    }
                                });
                                if (newproducts.length > 0) {
                                    runSortOn(valc.iconList);
                                    if (state == "future") {
                                        // TG Hack: for future, we got some products based on member level covEffDate.
                                        // So, from valc.products, remove all the PAST products. Keep current products only.

                                        var ProductsToRemove = [];
                                        (newproducts || []).forEach(function(valP, indP) {
                                            if (valP.effectDate.policyState == "past") {
                                                ProductsToRemove.push(indP);
                                            }
                                        });
                                        ProductsToRemove.reverse();
                                        (ProductsToRemove || []).forEach(function(removeaa, removeindaa) {
                                            newproducts.splice(removeaa, 1);
                                        });
                                        valc.products = angular.copy(newproducts);
                                    } else
                                        valc.products = angular.copy(newproducts);

                                    valc.showGroup = true;
                                    // need to reset group effectdate here maybe
                                    valc.effectDate = {
                                        'beginDate': valc.products[0].effectDate.beginDate,
                                        'endDate': valc.products[0].effectDate.endDate,
                                        'policyState': state,
                                        //'covCancellationDate': valc.products[0].effectDate.covCancellationDate,
                                        'showDate': valc.products[0].effectDate.showDate
                                    };
                                } else {
                                    valc.products = angular.copy(newproducts);
                                }
                                // probably rerun the new card building from this list.
                                //if no products don't show group/card
                                if (valc.products.length == 0) {
                                    valc.showGroup = false;
                                }
                            });
                            // if no groups don't show member
                            // and remove groups (null)
                            var tempGroupCount = valb.groups.length;
                            var newGroupCount = 0;
                            var groupsToRemove = []; //
                            (valb.groups || []).forEach(function(checka, checkinda) {
                                if (checka.showGroup == false) {
                                    newGroupCount++;
                                    groupsToRemove.push(checkinda);
                                }
                            });

                            if (tempGroupCount == newGroupCount) {
                                valb.showMember = false;
                                valb.groups = null;
                            } else {
                                groupsToRemove.reverse();
                                (groupsToRemove || []).forEach(function(removeaa, removeindaa) {
                                    valb.groups.splice(removeaa, 1);
                                });
                            }
                        });
                        // if no members don't show client
                        // and remove members (null)
                        var tempMemberCount = vala.members.length;
                        var newMemberCount = 0;
                        var membersToRemove = [];
                        (vala.members || []).forEach(function(checkb, checkindb) {
                            var dtcoverageEffectiveDate = new Date(checkb.coverageEffectiveDate);
                            if (state == "future" && checkb.covCancellationDate != "") {
                                var dtcoverageCancellationDate = new Date(checkb.covCancellationDate);
                                dtcoverageEffectiveDate = dtcoverageCancellationDate;
                            }
                            var dtToday = getServerDate();

                            if (state == "future") {
                                // hack to check if this member has a future effective plan. This field was not avail in ums when this file was coded - TG
                                checkb.showMember = (dtcoverageEffectiveDate > dtToday);
                            } else {
                                checkb.showMember = (dtcoverageEffectiveDate <= dtToday);
                            }

                            if (!checkb.showMember) {
                                newMemberCount++;
                                membersToRemove.push(checkindb);
                            }
                        });
                        if (tempMemberCount == newMemberCount) {
                            vala.showClient = false;
                            vala.members = null;
                        } else {
                            membersToRemove.reverse();
                            (membersToRemove || []).forEach(function(removeaaa, removeindaaa) {
                                vala.members.splice(removeaaa, 1);
                            });
                        }
                        vala.members = removeDuplicatesMembersWithoutDates(vala.members);
                        //if no member don't show client
                        //showClient
                    });
                    var clientsToRemove = [];
                    (list.clientList || []).forEach(function(checkc, checkindc) {
                        if (checkc.showClient == false) {
                            clientsToRemove.push(checkindc);
                        }
                    });
                    clientsToRemove.reverse();
                    (clientsToRemove || []).forEach(function(removea, removeinda) {
                        list.clientList.splice(removea, 1);
                    });

                    return list;
                },



                /** openFirstPerson - on visiting the page only the first drawer should be open
                I have put this into a different functions and this has not been built out.*/
                openFirstPerson: function() {
                    // get to this later... not needed just yet.
                },
                /**getUniqueMemberName - is from user.js - it is used for a unique name for each member
                 */
                getUniqueMemberName: function(name, dob) {
                    return name + " (" + dob + ")";
                },



                /**getModuloValue used for css banding on the page (because of ie8)*/
                getModuloValue: function(list) {
                    (list || []).forEach(function(vala, inda) {
                        vala.moduloPlacement = inda;
                    });
                },
                /**getDOBShowFlag - users with duplicate names but are not of the same birthdate
                ,i.e.- a son named after his father, should show their birthday so a user can tell 
                whom they are actually looking at*/
                getDOBShowFlag: function(list) {
                    var tempArray = [];
                    (list || []).forEach(function(vala, inda) {
                        var tempObj = {
                            "dob": vala.dob,
                            person: {
                                "first": vala.firstName,
                                "last": vala.lastName
                            }
                        };
                        tempArray.push(tempObj);
                    });
                    (tempArray || []).forEach(function(vala, inda) {
                        (list || []).forEach(function(valb, indb) {
                            if (inda != indb) {
                                var tempObj2 = {
                                    "dob": valb.dob,
                                    person: {
                                        "first": valb.firstName,
                                        "last": valb.lastName
                                    }
                                };
                                var compare = angular.equals(vala.person, tempObj2.person);
                                if (compare && vala.dob != valb.dob) {
                                    valb.showDOB = true;
                                }
                                /*if(valb.showDOB == false){
                                    valb.showDOB = compare;
                                }*/

                            }

                        });
                    });


                },
                /**getPolicyState - This gets the policies state based on their effective dates.*/
                getPolicyState: function(beginDate, endDate, showDate, date, con, lob, intN) {
                    // returns current past future
                    if (!beginDate) {
                        beginDate = con;
                    }
                    var state,
                        bDate = new Date(beginDate),
                        eDate = new Date(endDate),
                        conDate = new Date(con);

                    /*Updates the endDate to the last possible millisecond of coverage*/
                    if (eDate) {
                        eDate = new Date(eDate.getFullYear(), eDate.getMonth(), eDate.getDate(), 23, 59, 59, 999);
                    }

                    /*check coverageConBeginDate rule*/
                    if (conDate > date) {
                        /*if the conDate is after the systemDate it is return 'future'. 
                        we don't display future dates per the rule now.*/
                        return "future";
                    }

                    //* do i have a begin date and no end date
                    if (lob == "Vision" && intN == "false") {
                        if (!beginDate && !endDate) {
                            state = "current";
                            //endDate = "Current"
                            return state;
                        }
                    }
                    if (beginDate && !endDate) {
                        state = "current";
                        //endDate = "Current"
                        return state;
                    }
                    //* do i have a begin date and an end date.
                    if (beginDate && endDate && (bDate <= date && eDate >= date)) {
                        state = "current";
                        /*// old future policy logic - overridding this with coverageConBeginDate rule.
                         }else if (beginDate && endDate && (bDate > date)) {
                             state = "future";*/
                    } else if (beginDate && endDate && (eDate < date)) {
                        state = "past";
                    }
                    //* end date and no begin date   and integrated is false 
                    // if (!beginDate && endDate && (showDate == false)){
                    if (!beginDate && endDate) {
                        if (eDate > date) {
                            state = "current";
                        } else if (eDate < date) {
                            state = "past";
                        }
                    }
                    return state;
                    /*business rule : if on med or dental (current) no  plan period end date is returned 
                    the system should idicate to the user the plan is current*/
                },
                /**getMemberValue  - is used for a placement value to run a sort on members
                'subscriber', 'spouse' 'dependant'  */
                getMemberValue: function(relationship) {
                    var memberValue = 0;
                    switch (relationship) {
                        case "Subscriber":
                            memberValue = 0;
                            break;
                        case "Spouse":
                            memberValue = 1;
                            break;
                        case "Dependent":
                            memberValue = 2;
                            break;
                        default:
                            memberValue = 3;
                            break;
                    }
                    return memberValue;

                },
                currentMember: function() {
                    var list = this.fullMemberList();
                    for (var z = 0; z < list.length; z++) {
                        var current = list[z];
                        if (current.relationship === "Subscriber") {
                            return current;
                        }
                    }
                    return list[0];
                }


            };

            return umsParse;
        };
	}]);
    // Below for testing only
    // bootstrap.run(["hook", function(hook) {
    //     hook.register('sessionStart', ["UMSParse", "sessionData", "$timeout", function(UMSParse, sessionData, $timeout) {
    //         $timeout(function() {
    //             var ums = new UMSParse(sessionData.memberInfo, new Date());
    //             console.log(ums.baseInformation());
    //             // console.log(ums.clientMemberList(clientInt));
    //             console.log(ums.clients());
    //             console.log(ums.currentMember());
    //             console.log(ums.fullGroupList());
    //             console.log(ums.fullMemberList());
    //             console.log(ums.fullProductList());
    //             // console.log(ums.getDOBShowFlag(list));
    //             console.log(ums.getFilterState());
    //             // console.log(ums.getMemberValue(relationship));
    //             // console.log(ums.getModuloValue(list));
    //             console.log(ums.getPlansForWhen());
    //             // console.log(ums.getPolicyState(beginDate,endDate,showDate,date,con,lob,intN));
    //             // console.log(ums.getPortalSelectedClient(clients,groupNumber));
    //             // console.log(ums.getPortalSelectedPlan(gn,ed));
    //             // console.log(ums.getSpecificMember(memberObj,product,groupNumber,clientNumber));
    //             // console.log(ums.getUniqueMemberName(name,dob));
    //             // console.log(ums.groupMemberList(clientInt,groupInt));
    //             // console.log(ums.memberListHasProductsPerFilter(list));
    //             console.log(ums.memberListOfClients());
    //             // console.log(ums.memberListOfGroups(c));
    //             // console.log(ums.memberListOfProducts(c));
    //             console.log(ums.openFirstPerson());
    //         }, 3000);
    //     }]);
    // }]);
}
